import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { cn } from "../lib/utils";
const toneClass = {
    default: "",
    muted: "",
    accent: "text-accent-foreground",
};
/**
 * Page gutters, straight from the design prototype's `--section-gutter`. In
 * `cqw` rather than `vw` because every block renders inside `@container` (see
 * BlockRenderer): the CMS canvas device frames then reflow truthfully, while at
 * a real full-width viewport container width *is* viewport width, so the
 * prototype's numbers hold. `6.667cqw` is its `--m-gutter`, `25 / 375`.
 *
 * 901/1101 rather than 900/1100: the prototype's breaks are `width <= 900px`
 * and `width <= 1100px`, so the wider treatment starts one pixel above each.
 * Rounding them to 900/1100 would disagree at exactly those two widths.
 */
export const PAGE_GUTTER = "px-[6.667cqw] @min-[901px]:px-[clamp(40px,8cqw,88px)] @min-[1101px]:px-[clamp(24px,10.694cqw,154px)]";
const BlockBandContext = React.createContext({
    index: null,
});
export function BlockBandProvider({ index, children, }) {
    const value = React.useMemo(() => ({ index }), [index]);
    return (_jsx(BlockBandContext.Provider, { value: value, children: children }));
}
function useBlockBand() {
    return React.useContext(BlockBandContext);
}
export function Section({ tone, className, children, ...rest }) {
    const { index } = useBlockBand();
    const resolved = tone ?? (index != null && index % 2 === 1 ? "muted" : "default");
    return (_jsx("section", { className: cn("w-full", toneClass[resolved], className), ...rest, children: children }));
}
//# sourceMappingURL=_section.js.map